export { default } from './SuccessGif';
